import Model, { attr, belongsTo } from '@ember-data/model';
import type CompanyModel from './company';
import type LocationItemModel from './location-item';
import type StocktakingModel from './stocktaking';
import type { Type } from '@warp-drive/core-types/symbols';
import { tracked } from '@glimmer/tracking';

const formatter = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 2,
});

export default class StocktakingEntryModel extends Model {
  declare [Type]: 'stocktaking-entry';

  @belongsTo('stocktaking', { async: false, inverse: 'stocktakingEntries' })
  declare stocktaking: StocktakingModel;
  @belongsTo('location-item', { async: false, inverse: 'stocktakingEntries' })
  declare location_item: LocationItemModel;
  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;

  @attr('number')
  declare amount: number;
  @attr('date')
  declare changed_at: Date;

  @tracked hasSetAmount: boolean = true;

  get item() {
    return this.location_item?.item;
  }

  get displayAmount() {
    const container_size = this.item.container_size;
    return formatter.format(this.amount / container_size);
  }
  get virtual_amount(): number | '' {
    const val = Math.floor(this.amount / this.item.container_size);

    if (!this.hasSetAmount && val === 0) {
      return '';
    }

    return val;
  }
  set virtual_amount(value: number | string) {
    if (value === '') {
      this.amount = this.virtual_amount_single;
      this.hasSetAmount = false;
      return;
    }
    const newAmount = parseInt(value);
    if (Number.isNaN(newAmount)) {
      return;
    }
    this.hasSetAmount = true;
    this.amount =
      newAmount * this.item.container_size + this.virtual_amount_single;
  }
  get virtual_amount_single(): number | '' {
    const val = this.amount - this.virtual_amount * this.item.container_size;

    if (!this.hasSetAmount && val === 0) {
      return '';
    }
    return val;
  }
  set virtual_amount_single(value: number | string) {
    if (value === '') {
      this.amount = this.virtual_amount * this.item.container_size;
      this.hasSetAmount = false;
      return;
    }
    const newAmount = parseInt(value);
    if (Number.isNaN(newAmount)) {
      return;
    }
    this.hasSetAmount = true;
    this.amount = newAmount + this.virtual_amount * this.item.container_size;
  }
  get diff() {
    const container_size = this.item.container_size;
    const diff = Math.round(
      (this.location_item.proposal_amount - this.amount) / container_size
    );
    if (Number.isNaN(diff)) {
      return '(keine Zahl)';
    } else {
      return diff;
    }
  }
}
